import { ApiMethodExecutingError } from '../../../service/Errors';
import { captureException } from '../../../service/ErrorsReporting/ErrorsReporting';
import { ValidationErrorData } from '../../../typings/common';

export const SHOW_INTERNAL_BANNER_EDIT_REQUEST_ERROR = 'SHOW_INTERNAL_BANNER_EDIT_REQUEST_ERROR';
export type SHOW_INTERNAL_BANNER_EDIT_REQUEST_ERROR = typeof SHOW_INTERNAL_BANNER_EDIT_REQUEST_ERROR;

export interface ShowInternalBannerEditRequestError {
    type: SHOW_INTERNAL_BANNER_EDIT_REQUEST_ERROR;
    error: ValidationErrorData;
}

export function showInternalBannerEditRequestErrorAction(
    error: ApiMethodExecutingError | string
): ShowInternalBannerEditRequestError {
    if (error instanceof ApiMethodExecutingError) {
        captureException(error.getNativeError());

        return {
            type: SHOW_INTERNAL_BANNER_EDIT_REQUEST_ERROR,
            error: {
                code: 'showInternalBannerEditRequestError',
                text: error.getMessage()
            }
        };
    }

    captureException(new Error(error));

    throw error;
}
